/* Theme-owned tracking only. See reports/tracking-sources.md for Admin dependencies. */
(() => {
  if (window.woodConsentTrackingInitialized || window.Shopify?.designMode) return;
  window.woodConsentTrackingInitialized = true;

  const gtmId = 'GTM-P3MKFX7Q';
  const tiktokId = 'D6SNS9RC77UF6ENU265G';
  const denied = {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  };
  let gtmStarted = false;
  let tiktokStarted = false;
  let lastState = '';
  let featureRequested = false;
  let attempts = 0;

  // This queues consent, without fetching any Google code.
  window.dataLayer = window.dataLayer || [];
  function googleConsent() {
    window.dataLayer.push(arguments);
  }
  googleConsent('consent', 'default', denied);

  function readPermissions() {
    const privacy = window.Shopify?.customerPrivacy;
    try {
      if (
        typeof privacy?.analyticsProcessingAllowed !== 'function' ||
        typeof privacy?.marketingAllowed !== 'function' ||
        typeof privacy?.saleOfDataAllowed !== 'function'
      ) return null;

      return {
        analytics: privacy.analyticsProcessingAllowed() === true,
        marketing: privacy.marketingAllowed() === true,
        sale: privacy.saleOfDataAllowed() === true,
      };
    } catch (_) {
      // An unavailable privacy service must never imply consent.
      return null;
    }
  }

  function startGtm() {
    if (gtmStarted) return;
    gtmStarted = true;
    if (
      window.google_tag_manager?.[gtmId] ||
      document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${gtmId}"]`)
    ) return;

    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(script);
  }

  function tiktokQueue() {
    window.TiktokAnalyticsObject = 'ttq';
    const queue = (window.ttq = window.ttq || []);
    // Preserve an existing SDK/bootstrap supplied by another integration.
    if (typeof queue.load === 'function') return queue;

    queue.methods = [
      'page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once',
      'ready', 'alias', 'group', 'enableCookie', 'disableCookie',
      'holdConsent', 'revokeConsent', 'grantConsent',
    ];
    queue.setAndDefer = (target, method) => {
      target[method] = function () {
        target.push([method].concat(Array.prototype.slice.call(arguments)));
      };
    };
    queue.methods.forEach((method) => queue.setAndDefer(queue, method));
    queue.instance = (id) => {
      const instance = queue._i?.[id] || [];
      queue.methods.forEach((method) => queue.setAndDefer(instance, method));
      return instance;
    };
    queue.load = (id, options) => {
      const url = 'https://analytics.tiktok.com/i18n/pixel/events.js';
      queue._i = queue._i || {};
      queue._i[id] = [];
      queue._i[id]._u = url;
      queue._t = queue._t || {};
      queue._t[id] = Date.now();
      queue._o = queue._o || {};
      queue._o[id] = options || {};
      const script = document.createElement('script');
      script.async = true;
      script.src = `${url}?sdkid=${id}&lib=ttq`;
      document.head.appendChild(script);
    };
    return queue;
  }

  function updateTikTok(allowed) {
    if (!allowed) {
      if (tiktokStarted && typeof window.ttq?.revokeConsent === 'function') {
        window.ttq.revokeConsent();
      }
      return;
    }

    const queue = tiktokQueue();
    if (typeof queue.grantConsent === 'function') queue.grantConsent();
    if (tiktokStarted) return;
    tiktokStarted = true;
    if (
      queue._i?.[tiktokId] ||
      document.querySelector(`script[src*="sdkid=${tiktokId}"]`)
    ) return;
    queue.load(tiktokId);
    queue.page();
  }

  function applyPermissions() {
    const permissions = readPermissions();
    const state = permissions || { analytics: false, marketing: false, sale: false };
    const stateKey = JSON.stringify(state);
    if (stateKey === lastState) return permissions !== null;
    lastState = stateKey;
    const advertisingAllowed = state.marketing && state.sale;

    googleConsent('consent', 'update', {
      analytics_storage: state.analytics ? 'granted' : 'denied',
      ad_storage: advertisingAllowed ? 'granted' : 'denied',
      ad_user_data: advertisingAllowed ? 'granted' : 'denied',
      ad_personalization: advertisingAllowed ? 'granted' : 'denied',
    });
    window.dataLayer.push({
      event: 'wood_consent_updated',
      wood_analytics_allowed: state.analytics,
      wood_marketing_allowed: state.marketing,
      wood_sale_allowed: state.sale,
    });

    // Until its tags are audited, the mixed-purpose container needs all permissions.
    if (state.analytics && advertisingAllowed) startGtm();
    updateTikTok(advertisingAllowed);
    return permissions !== null;
  }

  function initializePrivacy() {
    if (applyPermissions()) return;
    if (!featureRequested && typeof window.Shopify?.loadFeatures === 'function') {
      featureRequested = true;
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          if (!error) applyPermissions();
        });
      } catch (_) {
        // Keep both integrations blocked; a later consent event can retry.
      }
    }
    // Shopify's bootstrap may arrive asynchronously. Stop polling after 30 seconds.
    if (attempts++ < 60) window.setTimeout(initializePrivacy, 500);
  }

  document.addEventListener('visitorConsentCollected', applyPermissions);
  window.addEventListener('pageshow', applyPermissions);
  initializePrivacy();
})();
